var _g, _defs;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgGooglePlay(_ref, svgRef) {
  let title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 40,
    height: 40,
    viewBox: "0 0 40 40",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_6336_96284)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M19.6998 19.2031L4.2998 35.3031C4.7998 37.0031 6.3998 38.3031 8.2998 38.3031C9.0998 38.3031 9.7998 38.1031 10.3998 37.7031L27.7998 27.8031L19.6998 19.2031Z",
    fill: "#EA4335"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M35.3004 16.4016L27.8004 12.1016L19.4004 19.5016L27.9004 27.8016L35.4004 23.6016C36.7004 22.9016 37.6004 21.5016 37.6004 20.0016C37.5004 18.5016 36.6004 17.1016 35.3004 16.4016Z",
    fill: "#FBBC04"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M4.3002 4.70312C4.2002 5.00313 4.2002 5.40313 4.2002 5.80313V34.3031C4.2002 34.7031 4.2002 35.0031 4.3002 35.4031L20.3002 19.7031L4.3002 4.70312Z",
    fill: "#4285F4"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M19.7998 20.0031L27.7998 12.1031L10.4998 2.30312C9.8998 1.90312 9.0998 1.70312 8.2998 1.70312C6.3998 1.70312 4.6998 3.00312 4.2998 4.70312L19.7998 20.0031Z",
    fill: "#34A853"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_6336_96284"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 40,
    height: 40,
    fill: "white"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgGooglePlay);
export default __webpack_public_path__ + "static/media/google-play.9b9165c28eb10f788927681448305825.svg";
export { ForwardRef as ReactComponent };